import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import Button from './Button';
import Logo from './Logo';
import { Link } from 'gatsby';
import { TbChevronRight, TbMenu2, TbPhoneCall, TbX } from 'react-icons/tb';

export default function Navbar({ data }:any) {

  const scrollBreakPoint = 75;
  const [ scrolled, setScrolled ] = useState(typeof window !== 'undefined' ? window.scrollY > scrollBreakPoint : false);
  const [ isOpened, setIsOpened ] = useState(false);

  const pathname = typeof window !== 'undefined' ? window.location.pathname : "";

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener("scroll", () => {
        setScrolled(window.scrollY > scrollBreakPoint);
      })
    }
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    if (isOpened) {
      const handleClickOutside = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (!target.closest('.mobile-menu') && !target.closest('.menu-toggle')) {
          setIsOpened(false);
        }
      };
      
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpened]);

  return (
    <div className={`flex items-center justify-between w-full fixed px-4 lg:px-24 z-[100] transition-all ${scrolled ? 
      `bg-white backdrop-blur-sm border-b border-gray-100 !h-[65px] max-h-[calc(100svh-65px)] shadow-sm` : 
      `h-[90px] max-h-[calc(100svh-90px)] bg-transparent backdrop-blur-sm`}`}>
      <div className='flex items-center gap-24'>
        <Link to='/' className="relative z-10">
          <Logo 
            sizeClass={`w-[40px] h-[40px] ${scrolled && `!w-[34px] !h-[34px]`}`}
            textSizeClass={`text-2xl ${scrolled && `!text-xl`} !inline-block`}
          />
        </Link>
        <div className={`mobile-menu items-center transition-all flex flex-col fixed left-0 top-[90px] w-full pb-4 pt-4 bg-white/95 backdrop-blur-sm -mt-1 border-b border-gray-100 ${
          scrolled && `!top-[65px]`} ${
          !isOpened && `!border-transparent !pb-0 !pt-0 h-0 overflow-hidden`
        } lg:!gap-12 lg:!relative lg:!flex lg:!flex-row lg:!h-auto lg:!top-0 lg:!py-0 lg:!border-transparent lg:!bg-transparent lg:!mt-0 lg:!overflow-visible ${
          scrolled ? `max-h-[calc(100svh-60px)]` : `max-h-[calc(100svh-85px)]`}`}>
          <Link 
            className="flex items-center justify-between w-full flex-1 px-6 lg:!px-0 py-3 lg:py-0 hover:text-primary-500 transition-colors" 
            to='/'
          >
            <span className={`${pathname === "/" ? `text-primary-500 font-semibold` : ""}`}>Home</span>
            <TbChevronRight className='lg:hidden' />
          </Link>
          <Link 
            className="flex items-center justify-between w-full flex-1 px-6 lg:!px-0 py-3 lg:py-0 hover:text-primary-500 transition-colors" 
            to='/pricing'
          >
            <span className={`${pathname.includes("/pricing") ? `text-primary-500 font-semibold` : ""}`}>Pricing</span>
            <TbChevronRight className='lg:hidden' />
          </Link>
          <Link 
            className="flex items-center justify-between w-full flex-1 px-6 lg:!px-0 py-3 lg:py-0 hover:text-primary-500 transition-colors" 
            to='/features'
          >
            <span className={`${pathname.includes("/feature") ? `text-primary-500 font-semibold` : ""}`}>Features</span>
            <TbChevronRight className='lg:hidden' />
          </Link>
          <Link 
            className="flex items-center justify-between w-full flex-1 px-6 lg:!px-0 py-3 lg:py-0 hover:text-primary-500 transition-colors" 
            to='/industries'
          >
            <span className={`${pathname.includes("/industr") ? `text-primary-500 font-semibold` : ""}`}>Industries</span>
            <TbChevronRight className='lg:hidden' />
          </Link>
          <Link 
            className="flex items-center justify-between w-full flex-1 px-6 lg:!px-0 py-3 lg:py-0 hover:text-primary-500 transition-colors" 
            to='/blogs'
          >
            <span className={`${pathname.includes("/blog") ? `text-primary-500 font-semibold` : ""}`}>Blogs</span>
            <TbChevronRight className='lg:hidden' />
          </Link>
          <Link 
            className="flex items-center justify-between w-full flex-1 px-6 lg:!px-0 py-3 lg:py-0 hover:text-primary-500 transition-colors" 
            to='/partners'
          >
            <span className={`${pathname.includes("/partners") ? `text-primary-500 font-semibold` : ""}`}>Partners</span>
            <TbChevronRight className='lg:hidden' />
          </Link>
          <div className='w-full px-4 flex items-center gap-2 lg:hidden mt-4'>
            <Button
              className='flex-1'
              variant='secondary'
            >
              Log In
            </Button>
            <Button
              className='flex-1 flex items-center justify-center'
              variant='primary'
              size='sm'
              onClick={() => {
                window.open('https://meet.brevo.com/pipelime/drive-more-sales', '_blank')
              }}
            >
              <TbPhoneCall className='mr-2' />
              Schedule a call
            </Button>
          </div>
        </div>
      </div>
      <div className='flex items-center gap-4'>
        <Button
          variant='plain'
          className='hidden lg:block hover:text-primary-500 transition-colors'
        >
          Log In
        </Button>
        <Button
          variant='primary'
          size='sm'
          className='hidden lg:flex items-center justify-center shadow-sm hover:shadow-md transition-shadow'
          onClick={() => {
            window.open('https://meet.brevo.com/pipelime/drive-more-sales', '_blank')
          }}
        >
          <TbPhoneCall className='mr-2' />
          Schedule a call
        </Button>
        <button 
          className='menu-toggle lg:hidden text-3xl p-1 rounded-md hover:bg-gray-100 transition-colors'
          onClick={() => setIsOpened(!isOpened)}
          aria-label={isOpened ? "Close menu" : "Open menu"}
        >
          {isOpened 
            ? <TbX className='text-2xl' />
            : <TbMenu2 className='text-2xl' />
          }
        </button>
      </div>
    </div>
  )
}
